// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var AutocompleteVirtualizedJs = require("./AutocompleteVirtualized.js").default;

var make = AutocompleteVirtualizedJs;

exports.make = make;
/* make Not a pure module */
